<template>
  <div class="row">
    <div class="col-lg-8 inline">
      <h2>Vehicle Graph</h2>
    </div>
    <div class="col-lg-4">
      <span class="demonstration">Select Date Range :</span>
      <el-date-picker
        v-model="value2"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        @change="getDate()"
      ></el-date-picker>
    </div>
    <div class="col-lg-4">
      <h4>
        Select Site :
        <el-select
          class="select-primary tab"
          placeholder="Single Select"
          v-model="selects.simple_site"
          @change="getsitedata()"
        >
          <el-option
            v-for="option in selects.site"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4">
      <h4>
        Select Department :
        <el-select
          class="select-primary tab"
          placeholder="Single Select"
          v-model="selects.simple_dept"
          :disabled="disable"
          @change="getdepartmentdata()"
        >
          <el-option
            v-for="option in selects.dept"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-lg-12 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Availability</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="greenLineChart.loaded"
            :chart-data="greenLineChart.chartData"
            :gradient-colors="greenLineChart.gradientColors"
            :gradient-stops="greenLineChart.gradientStops"
            :extra-options="greenLineChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!greenLineChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Total Vehicle</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="pinkLineChart.loaded"
            :chart-data="pinkLineChart.chartData"
            :gradient-colors="pinkLineChart.gradientColors"
            :gradient-stops="pinkLineChart.gradientStops"
            :extra-options="pinkLineChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!pinkLineChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Breakdown</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="redLineChart.loaded"
            :chart-data="redLineChart.chartData"
            :gradient-colors="redLineChart.gradientColors"
            :gradient-stops="redLineChart.gradientStops"
            :extra-options="redLineChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!redLineChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Replacement</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="brightBlueLineChart.loaded"
            :chart-data="brightBlueLineChart.chartData"
            :gradient-colors="brightBlueLineChart.gradientColors"
            :gradient-stops="brightBlueLineChart.gradientStops"
            :extra-options="brightBlueLineChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!brightBlueLineChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Unserviced Vehicle</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="purpleLineChart.loaded"
            :chart-data="purpleLineChart.chartData"
            :gradient-colors="purpleLineChart.gradientColors"
            :gradient-stops="purpleLineChart.gradientStops"
            :extra-options="purpleLineChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!purpleLineChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Percentage Availability</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="ggLineChart.loaded"
            :chart-data="ggLineChart.chartData"
            :gradient-colors="ggLineChart.gradientColors"
            :gradient-stops="ggLineChart.gradientStops"
            :extra-options="ggLineChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!ggLineChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b class>Requirement</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="yellowLineChart.loaded"
            :chart-data="yellowLineChart.chartData"
            :gradient-colors="yellowLineChart.gradientColors"
            :gradient-stops="yellowLineChart.gradientStops"
            :extra-options="yellowLineChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!yellowLineChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { Select, Option, DatePicker } from "element-ui";
import moment from "moment";
import { sum, lab } from 'd3';
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    LineChart,
    BarChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    Loading,
    Circle8
  },
  data() {
    return {
      isLoading: true,
      // Selecting interval data
      selects: {
        site: [],
        dept: [],
        simple_site: "",
        simple_dept: ""
      },
      // date
      startdate: "",
      enddate: "",
      // disable filter
      disable: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() -
                  3600 * 1000 * 24 * 7 -
                  moment()
                    .subtract(1, "months")
                    .startOf("month")
                    .format()
              );
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value2: "",
      brightBlueLineChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Replacement",
              fill: true,
              borderColor: "rgba(52, 128, 252, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(52, 128, 252, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(52, 128, 252, 0.7)",
          "rgba(52, 128, 252, 0.0)",
          "rgba(52, 128, 252, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false
      },

      pinkLineChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Vehicle",
              fill: true,
              borderColor: "rgba(210, 84, 143, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(210, 84, 143, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(210, 84, 143, 0.5)",
          "rgba(210, 84, 143, 0.0)",
          "rgba(210, 84, 143, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false
      },

      redLineChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Breakdown",
              fill: true,
              borderColor: "rgba(237, 28, 36, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(237, 28, 36, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(237, 28, 36, 0.5)",
          "rgba(237, 28, 36, 0.0)",
          "rgba(237, 28, 36, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false
      },

      greenLineChart: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: "Availability",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false
      },

      ggLineChart: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: "Percentage Availability",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false
      },

      purpleLineChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Vehicle",
              fill: true,
              borderColor: "rgb(140, 100, 203, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgb(140, 100, 203, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(140, 100, 203, 0.7)",
          "rgba(140, 100, 203, 0.0)",
          "rgba(140, 100, 203, 0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false
      },

      yellowLineChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Requirement",
              fill: true,
              borderColor: "rgb(246, 206, 71, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgb(246, 206, 71, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(246, 206, 71, 0.5)",
          "rgba(246, 206, 71, 0.0)",
          "rgba(246, 206, 71, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false
      },
      
      // data
      availability: [],
      breakdown: [],
      percentage: [],
      replacement: [],
      requirement: [],
      totalvehicle: [],
      unserviced: [],
      // filter site data
      siteAvailability: [],
      siteTotalVehicle: [],
      siteBreakdown: [],
      siteReplacement: [],
      siteUnserviced: [],
      sitePercentage: [],
      siteRequirement: [],
      // filter dept data
      deptAvailability : [],
      deptTotalVehicle: [],
      deptBreakdown: [],
      deptReplacement: [],
      deptUnserviced: [],
      deptPercentage: [],
      deptRequirement:[]
    };
  },
  methods: {
    // async getDepartment(){
    //   this.greenLineChart.loaded = false
    //   this.redLineChart.loaded = false
    //   this.ggLineChart.loaded = false
    //   this.brightBlueLineChart.loaded = false
    //   this.yellowLineChart.loaded = false
    //   this.pinkLineChart.loaded = false
    //   this.purpleLineChart.loaded = false

    //   this.deptAvailability = []
    //   this.deptTotalVehicle = []
    //   this.deptBreakdown = []
    //   this.deptReplacement = []
    //   this.deptUnserviced = []
    //   this.deptPercentage = []
    //   this.deptRequirement = []

    //   if(this.selects.simple_dept != 'All'){
    //     // pull availability data
    //     for(var i=0; i<this.siteAvailability.length; i++){
    //       if(this.selects.simple_dept === this.siteAvailability[i].DeptName){
    //         this.deptAvailability.push(this.siteAvailability[i])
    //       }
    //     }
    //     console.log(this.deptAvailability)
    //     // pull total vehicle data
    //     for(var i=0; i<this.siteTotalVehicle.length; i++){
    //       if(this.selects.simple_dept === this.siteTotalVehicle[i].DeptName){
    //         this.deptTotalVehicle.push(this.siteTotalVehicle[i])
    //       }
    //     }
    //     // pull breakdown data
    //     for(var i=0; i<this.siteBreakdown.length; i++){
    //       if(this.selects.simple_dept === this.siteBreakdown[i].DeptName){
    //         this.deptBreakdown.push(this.siteBreakdown[i])
    //       }
    //     }
    //     // pull replacement data
    //     for(var i=0; i<this.siteReplacement.length; i++){
    //       if(this.selects.simple_dept === this.siteReplacement[i].DeptName){
    //         this.deptReplacement.push(this.siteReplacement[i])
    //       }
    //     }
    //     // pull unserviced data
    //     for(var i=0; i<this.siteUnserviced.length; i++){
    //       if(this.selects.simple_dept === this.siteUnserviced[i].DeptName){
    //         this.deptUnserviced.push(this.siteUnserviced[i])
    //       }
    //     }
    //     // pull percentage data
    //     for(var i=0; i<this.sitePercentage.length; i++){
    //       if(this.selects.simple_dept === this.sitePercentage[i].DeptName){
    //         this.deptPercentage.push(this.sitePercentage[i])
    //       }
    //     }
    //     // pull requirement data
    //     for(var i=0; i<this.siteRequirement.length; i++){
    //       if(this.selects.simple_dept === this.siteRequirement[i].DeptName){
    //         this.deptRequirement.push(this.siteRequirement[i])
    //       }
    //     }

    //     // availability
    //     let tempIndex = []
    //     let tempLabel = []
    //     this.greenLineChart.loaded = false
    //     let dataAvailability = []
    //     let labelAvailability = []
    //     for(var i=0; i<this.deptAvailability.length; i++){
    //       let a = this.deptAvailability[i].Created
    //       if(tempIndex.indexOf(a) === -1){
    //         tempIndex.push(a)
    //       }
    //     }
    //     // sort date
    //     tempIndex.sort(function(a,b){
    //       var da = new Date(a).getTime();
    //       var db = new Date(b).getTime();
          
    //       return da < db ? -1 : da > db ? 1 : 0
    //     });

    //     for(var i=0; i<tempIndex.length; i++){
    //       let total = 0
          
    //       for(var j=0; j<this.deptAvailability.length; j++){
    //         // do summation if date is equal
    //         if(tempIndex[i] === this.deptAvailability[j].Created){
    //           total += this.deptAvailability[j].Total
    //         }
    //       }
          
    //       dataAvailability.push(total)
    //       let n = moment(tempIndex[i]).format('YYYY-MM-DD')
    //       labelAvailability.push(n)
    //     }
        
    //     this.greenLineChart = {
    //       chartData: {
    //         labels: labelAvailability,
    //             datasets: [
    //               {
    //                 label: "Availability",
    //                 fill: true,
    //                 borderColor: "rgba(94, 170, 30, 1)",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "rgba(94, 170, 30, 1)",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#be55ed",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: dataAvailability
    //               }
    //             ]
    //           },
    //           loaded: false,
    //           extraOptions: chartConfigs.purpleChartOptions,
    //           gradientColors: [
    //             "rgba(94, 170, 30, 0.5)",
    //             "rgba(94, 170, 30, 0.0)",
    //             "rgba(94, 170, 30, 0.0)"
    //           ],
    //           gradientStops: [1, 0.4, 0]   
    //       };    
        
    //       this.greenLineChart.loaded = true

    //       // breakdown
    //       let tempIndexBreakdown = []
    //       this.redLineChart.loaded = false
    //       let dataBreakdown = []
    //       let labelBreakdown = []
    //       for(var i=0; i<this.deptBreakdown.length; i++){
    //         let a = this.deptBreakdown[i].VehBreakDate
    //         if(tempIndexBreakdown.indexOf(a) === -1){
    //           tempIndexBreakdown.push(a)
    //         }
    //       }
    //       // sort date
    //       tempIndexBreakdown.sort(function(a,b){
    //         var da = new Date(a).getTime();
    //         var db = new Date(b).getTime();
            
    //         return da < db ? -1 : da > db ? 1 : 0
    //       });

    //       for(var i=0; i<tempIndexBreakdown.length; i++){
    //         let total = 0
            
    //         for(var j=0; j<this.deptBreakdown.length; j++){
    //           // do summation if date is equal
    //           if(tempIndexBreakdown[i] === this.deptBreakdown[j].VehBreakDate){
    //             total += this.deptBreakdown[j].Total
    //           }
    //         }
            
    //         dataBreakdown.push(total)
    //         let n = moment(tempIndexBreakdown[i]).format('YYYY-MM-DD')
    //         labelBreakdown.push(n)
    //       }
         

    //       this.redLineChart = {
    //           chartData: {
    //             labels: labelBreakdown,
    //             datasets: [
    //               {
    //                 label: "Breakdown",
    //                 fill: true,
    //                 borderColor: "rgba(237, 28, 36, 1)",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "rgba(237, 28, 36, 1)",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#be55ed",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: dataBreakdown
    //               }
    //             ]
    //           },
    //           loaded: false,
    //           extraOptions: chartConfigs.purpleChartOptions,
    //           gradientColors: [
    //             "rgba(237, 28, 36, 0.5)",
    //             "rgba(237, 28, 36, 0.0)",
    //             "rgba(237, 28, 36, 0.0)"
    //           ],
    //           gradientStops: [1, 0.4, 0]
    //       };

    //       this.redLineChart.loaded = true

    //       // percentage
    //       let tempIndexPercentage = []
    //       this.ggLineChart.loaded = false
    //       let datapercentage = []
    //       let temppercentage = []
    //       let total = []
    //       for(var i=0; i<this.deptPercentage.length; i++){
            
    //         let a = this.deptPercentage[i].Created
    //         if(tempIndexPercentage.indexOf(a) === -1){
    //           tempIndexPercentage.push(a)
    //         }
    //       }
    //       // sort date
    //       tempIndexPercentage.sort(function(a,b){
    //         var da = new Date(a).getTime();
    //         var db = new Date(b).getTime();
            
    //         return da < db ? -1 : da > db ? 1 : 0
    //       });
        
    //       for(var i=0; i<tempIndexPercentage.length; i++){
    //         let total = 0
    //         let avail = 0
            
    //         for(var j=0; j<this.deptPercentage.length; j++){
    //           // do summation if date is equal
    //           if(tempIndexPercentage[i] === this.deptPercentage[j].Created){
    //             total += this.deptPercentage[j].Total
    //             avail += this.deptPercentage[j].Available
    //           }
    //         }
    //         if(total == 0){
    //           total = 1
    //         }
    //         let percent = (avail * 100) / total
            
    //         datapercentage.push(percent.toFixed(0))
    //         let n = moment(tempIndexPercentage[i]).format('YYYY-MM-DD')
    //         temppercentage.push(n)
    //       }

    //       this.ggLineChart = {
    //           chartData: {
    //             labels: temppercentage,
    //             datasets: [
    //               {
    //                 label: "Percentage Availability",
    //                 fill: true,
    //                 borderColor: "rgba(94, 170, 30, 1)",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "rgba(94, 170, 30, 1)",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#be55ed",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: datapercentage
    //               }
    //             ]
    //           },
    //           loaded: false,
    //           extraOptions: chartConfigs.purpleChartOptions,
    //           gradientColors: [
    //             "rgba(94, 170, 30, 0.5)",
    //             "rgba(94, 170, 30, 0.0)",
    //             "rgba(94, 170, 30, 0.0)"
    //           ],
    //           gradientStops: [1, 0.4, 0]
    //         };

    //         this.ggLineChart.loaded = true

    //       // replacement
    //       let tempIndexReplacement = []
    //       this.brightBlueLineChart.loaded = false
    //       let datareplacement = []
    //       let tempreplacement = []
    //       for(var i=0; i<this.deptReplacement.length; i++){
    //         let a = this.deptReplacement[i].VehReplacementDate
    //         if(tempIndexReplacement.indexOf(a) === -1){
    //           tempIndexReplacement.push(a)
    //         }
    //       }
    //       // sort date
    //       tempIndexReplacement.sort(function(a,b){
    //         var da = new Date(a).getTime();
    //         var db = new Date(b).getTime();
            
    //         return da < db ? -1 : da > db ? 1 : 0
    //       });
          
    //       for(var i=0; i<tempIndexReplacement.length; i++){
    //         let total = 0
            
    //         for(var j=0; j<this.deptReplacement.length; j++){
    //           // do summation if date is equal
    //           if(tempIndexReplacement[i] === this.deptReplacement[j].VehReplacementDate){
    //             total += this.deptReplacement[j].Total
    //           }
    //         }
            
    //         datareplacement.push(total)
    //         let n = moment(tempIndexReplacement[i]).format('YYYY-MM-DD')
    //         tempreplacement.push(n)
    //       }

    //       this.brightBlueLineChart = {
    //           chartData: {
    //             labels: tempreplacement,
    //             datasets: [
    //               {
    //                 label: "Replacement",
    //                 fill: true,
    //                 borderColor: "rgba(52, 128, 252, 1)",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "rgba(52, 128, 252, 1)",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#be55ed",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: datareplacement
    //               }
    //             ]
    //           },
    //           loaded: false,
    //           extraOptions: chartConfigs.purpleChartOptions,
    //           gradientColors: [
    //             "rgba(52, 128, 252, 0.7)",
    //             "rgba(52, 128, 252, 0.0)",
    //             "rgba(52, 128, 252, 0.0)"
    //           ],
    //           gradientStops: [1, 0.4, 0]
    //         };

    //         this.brightBlueLineChart.loaded = true

    //       // requirement
    //       let tempIndexRequirement = []
    //       this.yellowLineChart.loaded = false
    //       let datarequirement = []
    //       let temprequirement = []
    //       for(var i=0; i<this.deptRequirement.length; i++){
    //         let a = this.deptRequirement[i].Created
    //         if(tempIndexRequirement.indexOf(a) === -1){
    //           tempIndexRequirement.push(a)
    //         }
    //       }
    //       // sort date
    //       tempIndexRequirement.sort(function(a,b){
    //         var da = new Date(a).getTime();
    //         var db = new Date(b).getTime();
            
    //         return da < db ? -1 : da > db ? 1 : 0
    //       });
          
    //       for(var i=0; i<tempIndexRequirement.length; i++){
    //         let total = 0
            
    //         for(var j=0; j<this.deptRequirement.length; j++){
    //           // do summation if date is equal
    //           if(tempIndexRequirement[i] === this.deptRequirement[j].Created){
    //             total += this.deptRequirement[j].Total
    //           }
    //         }
            
    //         datarequirement.push(total)
    //         let n = moment(tempIndexRequirement[i]).format('YYYY-MM-DD')
    //         temprequirement.push(n)
    //       }

    //       this.yellowLineChart = {
    //           chartData: {
    //             labels: temprequirement,
    //             datasets: [
    //               {
    //                 label: "Requirement",
    //                 fill: true,
    //                 borderColor: "rgb(246, 206, 71, 1)",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "rgb(246, 206, 71, 1)",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#be55ed",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: datarequirement
    //               }
    //             ]
    //           },
    //           loaded: false,
    //           extraOptions: chartConfigs.purpleChartOptions,
    //           gradientColors: [
    //             "rgba(246, 206, 71, 0.5)",
    //             "rgba(246, 206, 71, 0.0)",
    //             "rgba(246, 206, 71, 0.0)"
    //           ],
    //           gradientStops: [1, 0.4, 0]
    //         };

    //       this.yellowLineChart.loaded = true

    //       // total vehicle
    //       let tempIndexTotalvehicle = []
    //       this.pinkLineChart.loaded = false
    //       let datatotalvehicle = []
    //       let temptotalvehicle = []
    //       for(var i=0; i<this.deptTotalVehicle.length; i++){
    //         let a = this.deptTotalVehicle[i].Created
    //         if(tempIndexTotalvehicle.indexOf(a) === -1){
    //           tempIndexTotalvehicle.push(a)
    //         }
    //       }
    //       // sort date
    //       tempIndexTotalvehicle.sort(function(a,b){
    //         var da = new Date(a).getTime();
    //         var db = new Date(b).getTime();
            
    //         return da < db ? -1 : da > db ? 1 : 0
    //       });
          
    //       for(var i=0; i<tempIndexTotalvehicle.length; i++){
    //         let total = 0
            
    //         for(var j=0; j<this.deptTotalVehicle.length; j++){
    //           // do summation if date is equal
    //           if(tempIndexTotalvehicle[i] === this.deptTotalVehicle[j].Created){
    //             total += this.deptTotalVehicle[j].Total
    //           }
    //         }
            
    //         datatotalvehicle.push(total)
    //         let n = moment(tempIndexTotalvehicle[i]).format('YYYY-MM-DD')
    //         temptotalvehicle.push(n)
    //       }

    //       this.pinkLineChart = {
    //           chartData: {
    //             labels: temptotalvehicle,
    //             datasets: [
    //               {
    //                 label: "Total Vehicle",
    //                 fill: true,
    //                 borderColor: "rgba(210, 84, 143, 1)",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "rgba(210, 84, 143, 1)",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#be55ed",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: datatotalvehicle
    //               }
    //             ]
    //           },
    //           loaded: false,
    //           extraOptions: chartConfigs.purpleChartOptions,
    //           gradientColors: [
    //             "rgba(210, 84, 143, 0.5)",
    //             "rgba(210, 84, 143, 0.0)",
    //             "rgba(210, 84, 143, 0.0)"
    //           ],
    //           gradientStops: [1, 0.4, 0]
    //         };

    //       this.pinkLineChart.loaded = true

    //       // unserviced
    //       let tempIndexUnserviced = []
    //       this.purpleLineChart.loaded = false
    //       let dataunserviced = []
    //       let tempunserviced = []
    //       for(var i=0; i<this.deptUnserviced.length; i++){
    //          let a = this.deptUnserviced[i].Created
    //         if(tempIndexUnserviced.indexOf(a) === -1){
    //           tempIndexUnserviced.push(a)
    //         }
    //       }
    //       // sort date
    //       tempIndexUnserviced.sort(function(a,b){
    //         var da = new Date(a).getTime();
    //         var db = new Date(b).getTime();
            
    //         return da < db ? -1 : da > db ? 1 : 0
    //       });
          
    //       for(var i=0; i<tempIndexUnserviced.length; i++){
    //         let total = 0
            
    //         for(var j=0; j<this.deptUnserviced.length; j++){
    //           // do summation if date is equal
    //           if(tempIndexUnserviced[i] === this.deptUnserviced[j].Created){
    //             total += this.deptUnserviced[j].Total
    //           }
    //         }
            
    //         dataunserviced.push(total)
    //         let n = moment(tempIndexUnserviced[i]).format('YYYY-MM-DD')
    //         tempunserviced.push(n)
    //       }
          
    //       this.purpleLineChart = {
    //           chartData: {
    //             labels: tempunserviced,
    //             datasets: [
    //               {
    //                 label: "Unserviced",
    //                 fill: true,
    //                 borderColor: "rgb(140, 100, 203, 1)",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "rgb(140, 100, 203, 1)",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#be55ed",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: dataunserviced
    //               }
    //             ]
    //           },
    //           loaded: false,
    //           extraOptions: chartConfigs.purpleChartOptions,
    //           gradientColors: [
    //             "rgba(140, 100, 203, 0.7)",
    //             "rgba(140, 100, 203, 0.0)",
    //             "rgba(140, 100, 203, 0)"
    //           ],
    //           gradientStops: [1, 0.4, 0]
    //         };

    //         this.purpleLineChart.loaded = true

    //   } else {
    //     this.getData()

    //     this.deptAvailability = []
    //     this.deptTotalVehicle = []
    //     this.deptBreakdown = []
    //     this.deptReplacement = []
    //     this.deptUnserviced = []
    //     this.deptPercentage = []
    //     this.deptRequirement = []

    //     // availability
    //     for(var i=0; i<this.siteAvailability.length; i++){
    //       this.deptAvailability = this.siteAvailability
    //     }
    //     // total vehicle
    //     for(var i=0; i<this.siteTotalVehicle.length; i++){
    //       this.deptTotalVehicle = this.siteTotalVehicle
    //     }
    //     // breakdown
    //     for(var i=0; i<this.siteBreakdown.length; i++){
    //       this.deptBreakdown = this.siteBreakdown
    //     }
    //     // replacement
    //     for(var i=0; i<this.siteReplacement.length; i++){
    //       this.deptReplacement = this.siteReplacement
    //     }
    //     // unserviced
    //     for(var i=0; i<this.siteUnserviced.length; i++){
    //       this.deptUnserviced = this.siteUnserviced
    //     }
    //     // percentage
    //     for(var i=0; i<this.sitePercentage.length; i++){
    //       this.deptPercentage = this.sitePercentage
    //     }
    //     // requirement
    //     for(var i=0; i<this.siteRequirement.length; i++){
    //       this.deptRequirement = this.siteRequirement
    //     }  

    //   }

    // },
    getdepartmentdata(){
      this.greenLineChart.loaded = false;
      this.redLineChart.loaded = false;
      this.ggLineChart.loaded = false;
      this.brightBlueLineChart.loaded = false;
      this.yellowLineChart.loaded = false;
      this.pinkLineChart.loaded = false;
      this.purpleLineChart.loaded = false;
      console.log(this.selects.simple_site)
      if(this.selects.simple_dept == "All"){
        this.getsitedata()
      } else {
        console.log(":9993/api/v1/analytics/"+ this.selects.simple_site + "/" + this.startdate + "/" + this.enddate)
        this.$http.get(":9993/api/v1/analytics/"+ this.selects.simple_dept + "/" + this.selects.simple_site + "/" + this.startdate + "/" + this.enddate)
          .then(res =>{
            if(!res.error){
              let response = res.message
              console.log(response)
              this.availability = response.Available,
              this.breakdown = response.Breakdown,
              this.percentage = response.AvailablePercent,
              this.replacement = response.Replacement,
              this.requirement = response.Requirement,
              this.totalvehicle = response.TotalVehicle,
              this.unserviced = response.Unserviced
              
              this.getAvailability()
              this.getBreakdown()
              this.getPercentage()
              this.getReplacement()
              this.getRequirement()
              this.getTotalVehicle()
              this.getUnserviced()
            }
          })
      }
      
    },
    getsitedata(){
      this.greenLineChart.loaded = false;
      this.redLineChart.loaded = false;
      this.ggLineChart.loaded = false;
      this.brightBlueLineChart.loaded = false;
      this.yellowLineChart.loaded = false;
      this.pinkLineChart.loaded = false;
      this.purpleLineChart.loaded = false;
      console.log(this.selects.simple_site)

      this.selects.simple_dept = "All"
      
      if(this.selects.simple_site == "All"){
        this.disable = true;
        this.getAnalytic()
      } else {
      console.log(":9993/api/v1/analytics/"+ this.selects.simple_site +"/" + this.startdate + "/" + this.enddate)
      this.$http.get(":9993/api/v1/analytics/"+ this.selects.simple_site +"/" + this.startdate + "/" + this.enddate)
        .then(res =>{
          if(!res.error){
            let response = res.message
            console.log(response)
            this.availability = response.Available,
            this.breakdown = response.Breakdown,
            this.percentage = response.AvailablePercent,
            this.replacement = response.Replacement,
            this.requirement = response.Requirement,
            this.totalvehicle = response.TotalVehicle,
            this.unserviced = response.Unserviced
            
            this.getAvailability()
            this.getBreakdown()
            this.getPercentage()
            this.getReplacement()
            this.getRequirement()
            this.getTotalVehicle()
            this.getUnserviced()
          }
        })
        this.disable = false
      }
    },
    getAvailability(){
      this.greenLineChart.loaded = false
      let availability = this.availability
      console.log(availability)
      // availability
      let label = []
      let data = []
      for(var i=0; i<availability.length; i++){
        label.push(moment(availability[i].Date).format("YYYY-MM-DD"))
        data.push(availability[i].Count)
      }  

      this.greenLineChart = {
        chartData: {
          labels: label,
          datasets: [
            {
              label: "Availability",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: data
             }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false
      }

      this.greenLineChart.loaded = true

    },
    getBreakdown(){
      let breakdown = this.breakdown
      this.redLineChart.loaded = false
      
      //breakdown
      let tempLabel = []
      let tempdata = []
      for(var i=0; i<breakdown.length; i++){
        tempLabel.push(moment(breakdown[i].Date).format("YYYY-MM-DD"))
        tempdata.push(breakdown[i].Count)
      }  
      
            
      this.redLineChart = {
        chartData: {
          labels: tempLabel,
          datasets: [
          {
            label: "Breakdown",
            fill: true,
            borderColor: "rgba(237, 28, 36, 1)",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "rgba(237, 28, 36, 1)",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#be55ed",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: tempdata
          }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(237, 28, 36, 0.5)",
          "rgba(237, 28, 36, 0.0)",
          "rgba(237, 28, 36, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      };

      this.redLineChart.loaded = true

    },
    getPercentage(){
      let percentage = this.percentage
      this.ggLineChart.loaded = false
      // percentage availability
      let tempLabel = []
      let tempdata = []
      for(var i=0; i<percentage.length; i++){
        tempLabel.push(moment(percentage[i].Date).format("YYYY-MM-DD"))
        tempdata.push(percentage[i].PercentAvailable)
      }  
     
      this.ggLineChart = {
        chartData: {
          labels: tempLabel,
          datasets: [
          {
            label: "Percentage Availability",
            fill: true,
            borderColor: "rgba(94, 170, 30, 1)",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "rgba(94, 170, 30, 1)",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#be55ed",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: tempdata
          }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      };

      this.ggLineChart.loaded = true
    },
    getReplacement(){
      let replacement = this.replacement
      this.brightBlueLineChart.loaded = false
      console.log("replacement")
      // replacement
      let tempLabel = []
      let tempdata = []
      for(var i=0; i<replacement.length; i++){
        tempLabel.push(moment(replacement[i].Date).format("YYYY-MM-DD"))
        tempdata.push(replacement[i].Count)
      }  
           
            this.brightBlueLineChart = {
              chartData: {
                labels: tempLabel,
                datasets: [
                  {
                    label: "Replacement",
                    fill: true,
                    borderColor: "rgba(52, 128, 252, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(52, 128, 252, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: tempdata
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(52, 128, 252, 0.7)",
                "rgba(52, 128, 252, 0.0)",
                "rgba(52, 128, 252, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            };

            this.brightBlueLineChart.loaded = true
    },
    getRequirement(){
      let requirement = this.requirement
      this.yellowLineChart.loaded = false

      // requirement
      let tempLabel = []
      let tempdata = []
      for(var i=0; i<requirement.length; i++){
        tempLabel.push(moment(requirement[i].Date).format("YYYY-MM-DD"))
        tempdata.push(requirement[i].Count)
      }  
     
            this.yellowLineChart = {
              chartData: {
                labels: tempLabel,
                datasets: [
                  {
                    label: "Requirement",
                    fill: true,
                    borderColor: "rgb(246, 206, 71, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgb(246, 206, 71, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: tempdata
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(246, 206, 71, 0.5)",
                "rgba(246, 206, 71, 0.0)",
                "rgba(246, 206, 71, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            };

            this.yellowLineChart.loaded = true
    },
    getTotalVehicle(){
      let totalvehicle = this.totalvehicle
      this.pinkLineChart.loaded = false

      // total vehicle
      let tempLabel = []
      let tempdata = []
      for(var i=0; i<totalvehicle.length; i++){
        tempLabel.push(moment(totalvehicle[i].Date).format("YYYY-MM-DD"))
        tempdata.push(totalvehicle[i].Count)
      }  
      

            this.pinkLineChart = {
              chartData: {
                labels: tempLabel,
                datasets: [
                  {
                    label: "Total Vehicle",
                    fill: true,
                    borderColor: "rgba(210, 84, 143, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(210, 84, 143, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: tempdata
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(210, 84, 143, 0.5)",
                "rgba(210, 84, 143, 0.0)",
                "rgba(210, 84, 143, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            };

            this.pinkLineChart.loaded = true

    },
    getUnserviced(){
      let unserviced = this.unserviced
      this.purpleLineChart.loaded = false

      // unserviced
      let tempLabel = []
      let tempdata = []
      for(var i=0; i<unserviced.length; i++){
        tempLabel.push(moment(unserviced[i].Date).format("YYYY-MM-DD"))
        tempdata.push(unserviced[i].Count)
      }  
      
            this.purpleLineChart = {
              chartData: {
                labels: tempLabel,
                datasets: [
                  {
                    label: "Unserviced",
                    fill: true,
                    borderColor: "rgb(140, 100, 203, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgb(140, 100, 203, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: tempdata
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(140, 100, 203, 0.7)",
                "rgba(140, 100, 203, 0.0)",
                "rgba(140, 100, 203, 0)"
              ],
              gradientStops: [1, 0.4, 0]
            };

            this.purpleLineChart.loaded = true
    },
    getAnalytic(){
      
      var today = new Date();
      var day = today.getDay() || 7; 

      this.$http.get(":9993/api/v1/analytics/overall/" + this.startdate + "/" + this.enddate)
        .then(res =>{
          console.log(res.message)
          if (!res.error){
            let response = res.message
            console.log(response)
            this.availability = response.Available,
            this.breakdown = response.Breakdown,
            this.percentage = response.AvailablePercent,
            this.replacement = response.Replacement,
            this.requirement = response.Requirement,
            this.totalvehicle = response.TotalVehicle,
            this.unserviced = response.Unserviced
            
            this.getAvailability()
            this.getBreakdown()
            this.getPercentage()
            this.getReplacement()
            this.getRequirement()
            this.getTotalVehicle()
            this.getUnserviced()

            
          }
        })
    },
    getDate(){
      this.selects.simple_site = ""
      this.selects.simple_dept = ""
      this.greenLineChart.loaded = false
      this.redLineChart.loaded = false
      this.ggLineChart.loaded = false
      this.brightBlueLineChart.loaded = false
      this.yellowLineChart.loaded = false
      this.pinkLineChart.loaded = false
      this.purpleLineChart.loaded = false

      this.startdate = moment(this.value2[0]).unix();
      this.enddate = moment(this.value2[1]).unix();
      this.getAnalytic()

    },
    getSite(){
      this.selects.site = []
      // filter
      let all = {
        label: "All",
        value: "All"
      }

      this.selects.site.push(all)

      this.$http.get(":9993/api/v1/register/site")
        .then(res => {
          if(!res.error){
            let response = res.message
            console.log(response)
            for(var i=0; i<response.length; i++){
              let obj = {
                label: response[i].SiteName,
                value: response[i].SiteID
              }
              this.selects.site.push(obj)
            }
            
          }
        })
    },
    getDepartment(){
      this.selects.dept = []
      // filter
      let all = {
        label: "All",
        value: "All"
      }

      this.selects.dept.push(all)
      this.$http.get(":9993/api/v1/setting/department")
        .then(res => {
          if(!res.error){
            let response = res.message
            console.log(response)
            for(var i=0; i<response.length; i++){
              let obj = {
                label: response[i].DeptName,
                value: response[i].DeptID
              }
              this.selects.dept.push(obj)
            }
            
          }
        })
    }
  },
  created() {
    
    this.startdate = moment().startOf("isoWeek").unix()
    this.enddate = moment().endOf("isoWeek").unix()
    console.log(this.startdate, this.enddate)
    this.getAnalytic()
    this.getSite()
    this.getDepartment()
    console.log(this.selects.site)
    this.selects.simple_site = this.selects.site[0].value
    
    
    // console.log(
    //   moment()
    //     .subtract(1, "months")
    //     .startOf("month")
    //     .format("DD")
    // );
  }
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
}
hr {
  color: black;
  margin-top: 0%;
}
.card-title > b {
  color: #99e6ff;
}
</style>